import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'rutasturisticas/pdf';
const CONTEXT_BASE_HTML_PATH = 'rutasturisticas/html';
const CONTEXT_SINGLE_BASE_PATH = 'rutasturisticas/pdfindividual';
// #endregion

// #region Public functions
async function getTouristRoutePdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchTouristRoutePdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchTouristRouteHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getTouristRoutePdf,
  searchTouristRoutePdf,
  searchTouristRouteHtml,
};
